<template>
  <div class="contactus">
    <Title :msg="wordTitle"></Title>
    <div class="map">
      <iframe
        src="https://maps.google.com.tw/maps?f=q&hl=zh-TW&geocode=&q=清華大學台達館&z=16&output=embed&t="
        width="100%"
        height="400px"
      ></iframe>
    </div>

    <div class="contact_area">
      <div class="container">
        <Form :btncolor="btncolor"/>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Form from '@/components/only_form.vue';
import Title from '@/components/title_onecolorbg.vue';
import Footer from '@/components/footer_information.vue';


export default {
  data() {
    return {
      wordTitle: '聯繫我們',
      btncolor: ['contactus', 'only_form', 'hover-btn'], // 按鈕樣式設定class
      // btncolor: ['contactus', 'btn-primary'],
    };
  },
  components: {
    Form,
    Title,
    Footer,
  },
};
</script>

<style lang="scss" scoped>
.map iframe {
  border: none;
  padding-top: 5px;
}
.contact_area {
  width: 100%;
  padding: 60px 0;
  text-align: center;
  color: black;
}

</style>
